import React, { useLayoutEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import ReactGA from 'react-ga4';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './assets/styles/index.css';
import { DisplayNotificationProvider } from './contexts/DisplayNotificationContext';
import { hasPrerenderedContent, startHandoffFade } from './utils/prerenderHandoff';

// Initialize Google Analytics (production only)
// Guard prevents double-initialization from React StrictMode
let gaInitialized = false;
if (process.env.REACT_APP_GA_MEASUREMENT_ID && !gaInitialized) {
  ReactGA.initialize(process.env.REACT_APP_GA_MEASUREMENT_ID, {
    gtagOptions: {
      anonymize_ip: true,  // Enhanced privacy - anonymize user IP addresses
    },
  });
  gaInitialized = true;
}

// Prerendered pages arrive with a styled fallback in #root. createRoot (not
// hydrateRoot) replaces it on the first commit; PrerenderHandoff softens that
// swap with a short fade, started before the new content is painted.
function PrerenderHandoff({ root }) {
  useLayoutEffect(() => startHandoffFade(root), [root]);
  return null;
}

const rootElement = document.getElementById('root');
const hadPrerenderedContent = hasPrerenderedContent(rootElement);
const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    {hadPrerenderedContent && <PrerenderHandoff root={rootElement} />}
    <Router>
      <DisplayNotificationProvider>
        <App />
      </DisplayNotificationProvider>
    </Router>
  </React.StrictMode>
); 